import React from 'react';
import { ColumnDefinition } from '../../../../../models';
import { getClassName } from '../../../../functions/getClassName';

interface DataRowsProps<T = Record<string, any>> {
  data: T[];
  columns: ColumnDefinition[];
}

export const renderCell = (column: ColumnDefinition, row: Record<string, any>) =>
  column.render ? column.render(row[column.field], row) : String(row[column.field]);

export const cellClassName = (column: ColumnDefinition) =>
  column.groupStart
    ? `${getClassName(column.type)} pivot-group-start`
    : getClassName(column.type);

const DataRows = <T extends Record<string, any>>({
  data,
  columns,
}: DataRowsProps<T>) => {
  return (
    <>
      {data.map((row, i) => (
        <tr key={i}>
          {columns.map(
            column =>
              column.show && (
                <td key={String(column.field)} className={cellClassName(column)}>
                  {renderCell(column, row)}
                </td>
              )
          )}
        </tr>
      ))}
    </>
  );
};

export default DataRows;
